import { Routes } from '@angular/router';

export const cmsModuleRoutes: Routes = [
  { path: '', redirectTo: 'what-we-do', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'what-we-do',
    loadComponent: () => import('./what-we-do/what-we-do').then((m) => m.WhatWeDo),
    data: {
      name: 'What we do?',
    },
  },
  {
    path: 'documents',
    loadComponent: () => import('./cms-documents/cms-documents').then((m) => m.CmsDocuments),
    data: {
      name: 'Documents',
    },
  },
  {
    path: 'frequent-asked-questions',
    loadComponent: () =>
      import('./frequent-asked-questions/frequent-asked-questions').then(
        (m) => m.FrequentAskedQuestions,
      ),
    data: {
      name: 'FAQs',
    },
  },
];
